import { BuscarService } from 'src/app/services/buscar.service';
import { objClienteFrm } from 'src/app/modulos/archivos/interlocutor-comercial/cliente/cliente-nuevo/objConfiguracionCliente.model'
import { setConfigTable, basicAlert, timerOut, alertaConfirmacion } from 'src/app/shared/utils';
import { Cliente } from 'src/app/models/cliente.model';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ClienteService } from 'src/app/services/cliente.service'
import { VendedorService } from 'src/app/services/vendedor.service';
import * as moment from "moment";
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { ModalBusquedaInterlocutorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-interlocutor/modal-busqueda-interlocutor.component';
import { ClienteClase } from "src/app/models/ClienteClase.model";
import { CondicionesPago } from 'src/app/models/CondicionesPago.model';
import { ClienteContacto } from 'src/app/models/ClienteContacto.model';
import { CondicionPagoService } from 'src/app/services/condicion-pago.service'
import { ContactoService } from 'src/app/services/contacto.service'
import { Contacto } from 'src/app/models/Contacto.model';
import { ClienteDirecciones } from 'src/app/models/ClienteDirecciones.model';
import { bancoService } from 'src/app/services/bancos.service'
import { MonedaService } from 'src/app/services/moneda.service'
import { ClienteEspecificaciones } from 'src/app/models/ClienteEspecificaciones.model';
import { ClienteBancos } from 'src/app/models/ClienteBancos.model';
import { ImportarSunatComponent } from 'src/app/shared/modals/importar-sunat/importar-sunat.component';
import { RecursosService } from 'src/app/services/recursos.service';
import { StorageService } from 'src/app/services/storage.service';
import { DecimalPipe } from '@angular/common';
import { ContactoFrmComponent } from 'src/app/shared/modals/contacto-frm/contacto-frm.component';
import { ModalDireccionEnvioComponent } from 'src/app/shared/modals/modal-direccion-envio/modal-direccion-envio.component';
import { ModalDireccionEnvioUbigeoComponent } from 'src/app/shared/modals/modal-direccion-envio-ubigeo/modal-direccion-envio-ubigeo.component';
import { DataService } from 'src/app/services/dataService.service';
import { MdIcUbigeoEdtComponent } from 'src/app/shared/modals/md-ic-ubigeo-edt/md-ic-ubigeo-edt.component';
import { MdIcClaseEdtComponent } from 'src/app/shared/modals/md-ic-clase-edt/md-ic-clase-edt.component';
import { MdConsultaInterlocutorComponent } from 'src/app/shared/modals/md-consulta-interlocutor/md-consulta-interlocutor.component';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'app-modificar-cliente',
  templateUrl: './modificar-cliente.component.html',
  styleUrls: ['./modificar-cliente.component.css']
})
export class ModificarClienteComponent implements OnInit {
  @Input() codcli;
  @Input() codInterlocutor1:any;
  @ViewChild('selectInsertar') selectInsertar: ElementRef;
  @ViewChild('selectModificar') selectModificar: ElementRef
  @ViewChild('razon') razon: ElementRef;
  @ViewChild(ModificarClienteComponent) tableclases: ModificarClienteComponent | any;
  @ViewChild(ModificarClienteComponent) tablecondi: ModificarClienteComponent | any;
  @ViewChild(ModificarClienteComponent) tablecontactos: ModificarClienteComponent | any;
  @ViewChild(ModificarClienteComponent) tabledire: ModificarClienteComponent | any;
  @ViewChild(ModificarClienteComponent) tableespecificaciones: ModificarClienteComponent | any;
  @ViewChild(ModificarClienteComponent) tablebancos: ModificarClienteComponent | any;

  sessionInfo: any;
  //Vista - tipo -> 1 lista , 2 nuevo , 3 modificar 
  identidad: boolean = true;
  isnatural: boolean = true;
  vista: number = 1;
  tamanoidentidad: number;
  objCliente = new objClienteFrm();
  ParamDocumento = new Cliente();
  //llamar a servicios combo
  identidades: any = []
  vendedor: any = []
  titulolista: any = []
  tipopersona: any = []
  clienteRegimenes: any = []

  disabledInterlocutor: boolean = false;
  encontro: boolean = false;

  codigoCliente: any = [];

  public interlocutores: any[] = [];

  public mostrar: boolean = false;

  clientes: any = [];
  //Variables para Clase
  public codClase: number;
  public desClase: string;
  public codCodigoClase: number;
  public desCodigoClase: string;
  disabledCodigosClaseCombo: boolean = true;
  //Variables Modificar Clase
  editinputcla: any;
  editinputdescla: any;
  editinputcodigo: any;
  editinputdescodigo: any;
  editclase: any;
  editcond: any;
  editcontacto: any;
  editbanco: any;
  editespecificacion: any;
  //lista para clases
  clases = [];
  //lista para las condiciones de PAgo
  condicionesPago = [];
  //lista para contactos
  contactos = [];
  //lista para especificaciones
  especificaciones = [];
  //lista para direcciones de envío
  direcciones = [];
  //lista para bancos
  bancos = [];

  //combo para clases
  listaclases = [];
  listacodigos = [];
  listacondpago = [];

  financieras: any = [];
  tipocuentas: any = [];
  monedas: any = [];

  //  especificacion
  especificacion: any = [];
  //Checks de condicion de pago
  public codCondicionPago: number;
  public desCondicionPago: string;
  public predeterminado: boolean;
  public activo: boolean;
  //Modificar condiciones de pago
  public codCondicionPagoUpd: number;
  public desCondicionPagoUpd: string;
  public predeterminadoUpd: boolean;
  public activoUpd: boolean;

  //Atributos para crear direccion envío
  public codEnvio: number;
  public desEnvio: string = '';
  public direccionE1: string = '';
  public referenciaEnvio: string = '';
  public telefonoEnvio: string = '';
  public codEanEnvio: string = '';
  public celularEnvio: string = '';


  codBanco: number = null;
  desBanco: string = '';
  codTipoCuenta: number = null;
  desTipoCuenta: string = '';
  codMoneda: string = '';
  desMoneda: string = '';
  desCuenta: string = '';

  public disabledBotonBanco: boolean = true;
  public disabledTipoCuenta: boolean = true;
  public disabledMoneda: boolean = true;


  tident: string = '';
  //Clase temporal a guardar
  ClaseTemp = new ClienteClase()
  CondicionTemp = new CondicionesPago()
  EspecifiacionTemp = new ClienteEspecificaciones()
  DireccionTemp = new ClienteDirecciones()
  BancoTemp = new ClienteBancos()

  public clasesSelect: any[] = [];
  public mostrarTab: boolean = true;
  public disabledCliente: boolean = false;
  public flagDisabledButtons = true;

  public progressDirec1: string = '0%';
  public progressDirec2: string = '0%';
  public buscarLimpiarBoton: string = 'buscar';


  public disabledGuardar: boolean = true;


  closeResult = '';


  public tabModificar: boolean = false;
  public tabClases: boolean = true;
  public tabCondicionesPago: boolean = true;
  public tabCreditos: boolean = true;
  public tabContactos: boolean = true;
  public tabDireccionesEnvio: boolean = true;
  public tabEspecificaciones: boolean = true;
  public tabBanco: boolean = true;

  public _sunatImage: any = {};

  //ESPECIFICACION
  tipoConfirmar: string = 'Insert';
  //ENTRADAS
  public codEspecificacion: number;
  public desEspecificacion: string;
  public decimal: number;
  public texto: string;
  public caracter: string;
  public fecha: string;
  public tiempo: string;
  public numero: number;
  //MODALS DE DISABLED
  public disabledDecimal: boolean;
  public disabledTexto: boolean;
  public disabledCaracter: boolean;
  public disabledFecha: boolean;
  public disabledTiempo: boolean;
  public disabledNumero: boolean;

  //ATRIBUTOS DE MODIFICARBANCO

  codBancoUpd: number = null;
  desBancoUpd: string = '';
  codTipoCuentaUpd: number = null;
  desTipoCuentaUpd: string = '';
  codMonedaUpd: string = '';
  desMonedaUpd: string = '';
  desCuentaUpd: string = '';

  //ATRIBUTOS DIRECCION ENVIO
  codInterlocutor: string;
  codEnvioUpd: number;
  desEnvioUpd: string;
  direccionE1Upd: string;
  referenciaEnvioUpd: string;
  telefonoEnvioUpd: string;
  codEanEnvioUpd: string;
  celularEnvioUpd: string;
  botonUbigueoDireccionEnvio: boolean;

  //ATRIBUTOS ESPECIFICACIONES
  public disabledDecimalUpd: boolean = true;
  public disabledTextoUpd: boolean = true;
  public disabledCaracterUpd: boolean = true;
  public disabledFechaUpd: boolean = true;
  public disabledTiempoUpd: boolean = true;
  public disabledNumeroUpd: boolean = true;

  codEspecificacionUpd: number = null;
  desEspecificacionUpd: string = '';
  decimalUpd: number = null;
  textoUpd: string = '';
  caracterUpd: string = '';
  fechaUpd: string = '';
  tiempoUpd: string = '';
  numeroUpd: number = null;

  public _recursos: any = {};
  //public sessionInfo: any = null;

  decimalPrecio: any = 2;
  viewlimiteCredito: any = 0;

  _monedaFactor: string = "S/";

  Ubigeobloc: boolean = false;
  disable_codigo: any = false;
  constructor(
    private clienteService: ClienteService,
    private _buscarService: BuscarService,
    private spinnerService: SpinnerService,
    private VendedorService: VendedorService,
    private modalService: NgbModal,
    private interlocutorService: InterlocutorService,
    private CondicionPagoService: CondicionPagoService,
    private contactoService: ContactoService,
    private bancoService: bancoService,
    private MonedaService: MonedaService,
    private recursosService: RecursosService,
    private decimalPipe: DecimalPipe,
    public dataService: DataService,
    private toastr: ToastrService,
    private router: Router,
    private _route: ActivatedRoute,
    private modalService2: NgbActiveModal,

  ) {

   }

  ngOnDestroy() {
    this.dataService.vista = 0;
  }

  ngOnInit(): void {
    
    this.activo=true;
    this.encontro = true;
    this.disabledInterlocutor = false;

    this.sessionInfo = JSON.parse(StorageService.getSession());
    if (this.sessionInfo != null) {
      if (this.sessionInfo.factores != null)
        this._monedaFactor = this.sessionInfo.factores.monedaLimiteCreditoClientes
      console.log(this.sessionInfo);
    }
    if(this.codInterlocutor1!=null){
      console.log('este el codigo',this.codInterlocutor1);
      this.getByCodInterlocutor(this.codInterlocutor1,1);
    }
    if (this.sessionInfo.factores.codigoClienteAutomatico != null &&
      this.sessionInfo.factores.codigoClienteAutomatico == true) {
      this.disable_codigo = true;
    }

    this.objCliente.fecing = moment(new Date()).format("YYYY-MM-DD");
    this.spinnerService.activarLoading(true);
    this.recursosService.recursosIC().subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);

      this.objCliente.fecing = moment(new Date()).format("YYYY-MM-DD");
      this._recursos = resp.body;
      if (this._recursos != null && this._recursos.personas != null)
        this.tipopersona = this._recursos.personas;
      if (this._recursos != null && this._recursos.identidades != null)
        this.identidades = this._recursos.identidades;
      if (this._recursos != null && this._recursos.vendedores != null)
        this.vendedor = this._recursos.vendedores;
      if (this._recursos != null && this._recursos.tituloListas != null)
        this.titulolista = this._recursos.tituloListas;
      if (this._recursos != null && this._recursos.impositivos != null)
        this.clienteRegimenes = this._recursos.impositivos;

      this.obtenerListaClases();
      this.obtenerListaCondPago();
      //bancos
      this.getAdjuntos();

      this.ObtenerEntidad();
      this.ObtenerTipoCuentas();
      this.ObtenerMonedas();
      this.ObtenerEspecificaciones();
    

    }, err => {
      this.spinnerService.activarLoading(false);
    });

    timerOut(500).then((value: any) => {
      if (value) { 
        this.getByCodInterlocutor(this.codcli,1);
        this.razon.nativeElement.focus(); }
    })
  }

  ObtenerEspecificaciones() {
    this.interlocutorService.getEspecificaciones().subscribe(response => {

      this.especificacion = response.body;
    })
  }

  ObtenerEntidad() {
    this.bancoService.obtenerEntidad().subscribe(response => {

      this.financieras = response.body;
    })
  }
  ObtenerTipoCuentas() {
    this.bancoService.obtenerTipoCuentas().subscribe(response => {

      this.tipocuentas = response.body;
    })

  }

  ObtenerMonedas() {
    this.MonedaService.buscar().subscribe(response => {

      this.monedas = response.body.list;
    })

  }

  obtenerListaClases() {
    this.clienteService.buscarClases().subscribe(response => {
      this.listaclases = response.body;
    })
  }

  obtenerListaCondPago() {
    this.CondicionPagoService.busar("", true).subscribe(response => {
      this.listacondpago = response.body.list;
    })
  }

  onChangeClases(clase: any) {
    this.disabledCodigosClaseCombo = false;
    this.listacodigos = [];
    this.codCodigoClase = null;
    this.obtenerListaClasesCodigos(clase);
  }

  obtenerListaClasesCodigos(clase: any) {
    this.clienteService.buscarCodigos(clase).subscribe(response => {
      this.listacodigos = response.body;
    })

  }

  addClase() {
    this.spinnerService.activarLoading(true)
    const referenciaModal = this.modalService.open(MdIcClaseEdtComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.result.then((data) => {
      if (this.clases == null)
        this.clases = [];


      if (this.clases.find(x => x.clase == data.clase) != null) {
        basicAlert('El código de clase ya existe.', 'warning', 'Aceptar', null, null);
        return;
      }

      if (data != null) {
        this.clases.push(data);
      }

      if (this.clases.find(x => x.clase == 14) == null) {
        this.Ubigeobloc = false;
      } else {
        this.Ubigeobloc = true;
      }

    }, (reason) => {
      console.log(reason);
    });
  }

  addUbigeo() {
    const referenciaModal = this.modalService.open(MdIcUbigeoEdtComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.componentInstance.editar = false;
    referenciaModal.componentInstance.codDepart = "00";
    referenciaModal.result.then((data) => {
      if (this.clases == null)
        this.clases = [];
      if (data != null) {
        data.forEach(element => {
          this.clases.push(element);
        });
      }
      if (this.clases.find(x => x.clase == 14) == null) {
        console.log("CLASE CLASES 132")
        this.Ubigeobloc = false;
      } else {
        this.Ubigeobloc = true;
      }

    }, (reason) => {
      console.log(reason);
    });
  }


  editUbigeo() {

    let codDepart: string = '00';

    this.clases.forEach(element => {
      if (element.clase == 14) {
        codDepart = element.codigo;
      }
    });

    let codProv: string = null;
    this.clases.forEach(element => {
      if (element.clase == 15) {
        codProv = element.codigo;
      }
    });

    let codDist: string = null;
    this.clases.forEach(element => {
      if (element.clase == 16) {
        codDist = element.codigo;
      }
    });
    const referenciaModal = this.modalService.open(MdIcUbigeoEdtComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.componentInstance.editar = true;
    referenciaModal.componentInstance.codDepart = codDepart;
    referenciaModal.componentInstance.codProv = codProv;
    referenciaModal.componentInstance.codDist = codDist;
    referenciaModal.result.then((data) => {
      if (this.clases == null)
        this.clases = [];

      if (data != null) {

        this.clases.forEach(element => {
          if (element.clase == 14) {

            let departamento = data.find(item => item.clase == 14);;
            element.codigo = departamento.codigo;
            element.descodigo = departamento.descodigo;

          } else if (element.clase == 15) {

            let provincia = data.find(item => item.clase == 15);;

            element.codigo = provincia.codigo;
            element.descodigo = provincia.descodigo;


          } else if (element.clase == 16) {

            let distrito = data.find(item => item.clase == 16);
            element.codigo = distrito.codigo;
            element.descodigo = distrito.descodigo;


          }
        });

      }

      console.log(this.clases);

      if (this.clases.find(x => x.clase == 14) == null) {
        this.Ubigeobloc = false;
      } else {
        this.Ubigeobloc = true;
      }

    }, (reason) => {
      console.log(reason);
    });
  }

  
  editUbigeoDireccionesEnvio() {

    let codDepart: string = '00';

    this.clases.forEach(element => {
      if (element.clase == 14) {
        codDepart = element.codigo;
      }
    });

    let codProv: string = null;
    this.clases.forEach(element => {
      if (element.clase == 15) {
        codProv = element.codigo;
      }
    });

    let codDist: string = null;
    this.clases.forEach(element => {
      if (element.clase == 16) {
        codDist = element.codigo;
      }
    });
    const referenciaModal = this.modalService.open(MdIcUbigeoEdtComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.componentInstance.editar = true;
    referenciaModal.componentInstance.codDepart = codDepart;
    referenciaModal.componentInstance.codProv = codProv;
    referenciaModal.componentInstance.codDist = codDist;
    referenciaModal.result.then((data) => {
      if (this.direcciones == null)
        this.direcciones = [];

      if (data != null) {

        this.direcciones.forEach(element => {
          if (element.clase == 14) {

            let departamento = data.find(item => item.clase == 14);;
            element.codigo = departamento.codigo;
            element.descodigo = departamento.descodigo;

          } else if (element.clase == 15) {

            let provincia = data.find(item => item.clase == 15);;

            element.codigo = provincia.codigo;
            element.descodigo = provincia.descodigo;


          } else if (element.clase == 16) {

            let distrito = data.find(item => item.clase == 16);
            element.codigo = distrito.codigo;
            element.descodigo = distrito.descodigo;


          }
        });

      }

      console.log(this.direcciones);

      if (this.direcciones.find(x => x.clase == 14) == null) {
        this.Ubigeobloc = false;
      } else {
        this.Ubigeobloc = true;
      }

    }, (reason) => {
      console.log(reason);
    });
  }

  cancelarInsercion() {
    this.ParamDocumento = new Cliente();
    this.borrarDatos();
    this.vista = 1;
    this.mostrar = false;
    this.buscarLimpiarBoton = 'buscar';
    this.dataService.vista = 0;

    this.mostrar = false;
    this.disabledInterlocutor = false;
    this.encontro = true;
    this.cerrar()

    //this.dtTrigger.next();
    //this.dtTrigger.next();
  }
  borrarDatos() {
    this.encontro = true;
    this.disabledInterlocutor = false;
    this.encontro = true;

    this.objCliente = new objClienteFrm();
    this.disabledGuardar = true;
    this.objCliente.fecing = moment(new Date()).format("YYYY-MM-DD");

    setTimeout(() => {
      $('#codTipoDocumento').focus();
    }, 150);
  }
  onNexFocus(tipo: string) {
    if (tipo == 'Insert') {
      timerOut(10).then((value: any) => {
        if (value) { this.selectInsertar.nativeElement.focus(); }
      })
    } else {
      timerOut(10).then((value: any) => {
        if (value) { this.selectModificar.nativeElement.focus(); }
      })
    }
  }
  public messageTable = {
    emptyMessage: 'No hay información',
    totalMessage: 'total',
    selectedMessage: 'selected'
  }

  numerodident = 0;

  modificarCliente() {

    if (this.objCliente.dident == null  || this.objCliente.dident == '' || this.objCliente.dident == undefined) {
      this.numerodident = 0;
    }
    else {
      this.numerodident = this.objCliente.dident.toString().length;
    }

    console.log("this.numerodident")
    console.log(this.numerodident)
    console.log("this.tamanoidentidad")
    console.log(this.tamanoidentidad)
    
    if(this.objCliente.tident.toString() == '06' || this.objCliente.tident.toString()  == '01'){
      if (this.tamanoidentidad != 0 && (this.objCliente.dident == null)) {
        basicAlert('El campo "Doc. de identidad" es requerido y debe tener ' + this.tamanoidentidad + ' dígitos', 'warning', 'Aceptar', null, null, this.dident);
        return;
      }
    }


    if(this.objCliente.tident.toString() == '06' || this.objCliente.tident.toString()  == '01'){
      if (this.tamanoidentidad != 0 && this.numerodident != this.tamanoidentidad) {
        basicAlert('El campo "Doc. de identidad" debe tener ' + this.tamanoidentidad + ' dígitos', 'warning', 'Aceptar', null, null, this.dident);
        return;
    
      }
    }



    if (this.objCliente.codtpe == 2 && (this.objCliente.direc1 == '' || this.objCliente.direc1 == null)) {
      basicAlert('El campo "Dirección 1" es obligatorio y mayor a 10 dígitos.', 'warning', 'Aceptar', null, null);
      return;

    }


    this.ParamDocumento.id_cia = this.objCliente.id_cia;
    this.ParamDocumento.tipopersona = this.objCliente.tipopersona;
    this.ParamDocumento.valident = this.objCliente.valident;
    this.ParamDocumento.tident = this.objCliente.tident;
    this.ParamDocumento.codcli = this.objCliente.codcli;
    this.ParamDocumento.nombrescompletos = this.objCliente.nombrescompletos;
  
    this.ParamDocumento.direc1 = (this.objCliente.direc1 != undefined && this.objCliente.direc1 != null && this.objCliente.direc1.length > 0) ? this.objCliente.direc1.trim() : "";
    this.ParamDocumento.direc2 = (this.objCliente.direc2 != undefined && this.objCliente.direc2 != null && this.objCliente.direc2.length > 0) ? this.objCliente.direc2.trim() : "";
   

    this.ParamDocumento.apellidopaterno = this.objCliente.apellidopaterno;
    this.ParamDocumento.email = this.objCliente.email;
    this.ParamDocumento.apeliidomaterno = this.objCliente.apeliidomaterno;
    this.ParamDocumento.telefono = this.objCliente.telefono;
    this.ParamDocumento.nombres = this.objCliente.nombres;
    this.ParamDocumento.fax = this.objCliente.fax;
    this.ParamDocumento.nrodni = this.objCliente.nrodni;
    this.ParamDocumento.sexo = this.objCliente.sexo;
    this.ParamDocumento.titulolista = this.objCliente.titulolista;
    this.ParamDocumento.codven = this.objCliente.codven;
    this.ParamDocumento.exoimp = this.objCliente.exoimp;
    this.ParamDocumento.regret = this.objCliente.regret;
    this.ParamDocumento.observ = this.objCliente.observ;
    this.ParamDocumento.codtit = this.objCliente.codtit;
    this.ParamDocumento.codtpe = this.objCliente.codtpe;
    this.ParamDocumento.razonc = this.objCliente.razonc.trim();
    this.ParamDocumento.dident = this.objCliente.dident;
    this.ParamDocumento.fecing = moment(this.objCliente.fecing).format("YYYY-MM-DD");
    this.ParamDocumento.clases = this.clases;
    this.ParamDocumento.regret = this.objCliente.regret;
    this.ParamDocumento.contactos = this.contactos;
    this.ParamDocumento.condicionespago = this.condicionesPago;
    this.ParamDocumento.especificaciones = this.especificaciones;
    this.ParamDocumento.direccionesenvio = this.direcciones;
    this.ParamDocumento.bancos = this.bancos;
    this.ParamDocumento.codpag = +this.objCliente.credito;

    this.ParamDocumento.diasgracia = this.objCliente.diasgracia;
    this.ParamDocumento.limiteCredito = this.objCliente.limiteCredito;


    this.spinnerService.activarLoading(true);
    this.clienteService.actualizarCliente(this.ParamDocumento).subscribe(response => {
      this.spinnerService.activarLoading(false);


      this.disabledInterlocutor = false;
      this.encontro = true;
      if (response.status === 200) {
        this.toastr.success('Se actualizó correctamente.','',{ positionClass: 'toast-bottom-left'})
        this.borrarDatos();
        this.buscarLimpiarBoton = 'buscar';
        this.dataService.vista = 0;

        this.mostrar = false;
        this.ParamDocumento = new Cliente();
        this.vista = 1;
        this.cerrar()
      }
    }, error => {
      this.spinnerService.activarLoading(false);

      basicAlert(error.error, 'error', 'Aceptar');
    }
    );
  }
  onKeyEnterCodInterlocutor(e: any) {
    this.onBlurCodInterlocutor(this.objCliente.codcli);
  }

  onKeyEnterInterlocutor(e) {
    this.openModalInterlocutor();

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  onBlurCodInterlocutor(codcli: string) {
    if (codcli != null || codcli != '') {
      this.getByCodInterlocutor(codcli,1);
    }
  }

  getByCodInterlocutor(codcli: string,tipo: number) {

    this.codigoCliente = codcli;
    this.spinnerService.activarLoading(true);
    this.interlocutorService.obtenerInterlocutor(codcli, null).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.mostrar = true;


      this.disabledInterlocutor = true;
      this.encontro = false;


      this.objCliente.codcli = response.body.codcli;

      if(tipo == 1){
        this.objCliente.razonc = response.body.razonc;
        this.objCliente.codtpe = response.body.codtpe;
        this.objCliente.tident = response.body.tident;
        this.objCliente.dident = response.body.dident != null ? response.body.dident : '';
        this.objCliente.razonc = response.body.razonc != null ? response.body.razonc : '';
        this.objCliente.direc1 = response.body.direc1 != null ? response.body.direc1 : '';
      }

      this.objCliente.valident = response.body.valident;
      this.objCliente.fecing = response.body.fecing != null ? response.body.fecing : moment(new Date()).format("YYYY-MM-DD");;
      this.objCliente.direc2 = response.body.direc2 != null ? response.body.direc2 : '';
      this.objCliente.apellidopaterno = response.body.apellidopaterno != null ? response.body.apellidopaterno : '';
      this.objCliente.apeliidomaterno = response.body.apeliidomaterno != null ? response.body.apeliidomaterno : '';
      this.objCliente.nombres = response.body.nombres != null ? response.body.nombres : '';
      this.objCliente.email = response.body.email != null ? response.body.email : '';
      this.objCliente.telefono = response.body.telefono != null ? response.body.telefono : '';
      this.objCliente.fax = response.body.fax != null ? response.body.fax : '';
      this.objCliente.nrodni = response.body.nrodni != null ? response.body.nrodni : '';
      this.objCliente.sexo = response.body.sexo;
      this.objCliente.codven = response.body.codven;
      this.objCliente.codtit = response.body.codtit;
      this.objCliente.regret = response.body.regret;
      this.objCliente.observ = response.body.observ;
      this.objCliente.codpag = response.body.codpag;
      this.objCliente.exoimp = response.body.exoimp;
      this.objCliente.regret = response.body.regret;
      this.objCliente.factua=response.body.factua;
      this.objCliente.fcreac=response.body.fcreac;
      this.objCliente.ucreac=response.body.ucreac;
      this.objCliente.uactua=response.body.uactua;

      if (response.body.codpag == 0) {
        this.objCliente.credito = "0"
      }
      if (response.body.codpag == 1) {
        this.objCliente.credito = "1"
      }
      this.viewlimiteCredito = 0;
      this.objCliente.limiteCredito = response.body.limiteCredito;
      if (this.objCliente.limiteCredito != null && this.objCliente.limiteCredito > 0) {
        this.viewlimiteCredito = this.decimalPipe.transform(this.objCliente.limiteCredito, `0.${this.decimalPrecio}-${this.decimalPrecio}`);
      }

      this.objCliente.diasgracia = response.body.diasgracia;

      this.progressDirec1 = this.objCliente.direc1.length + '%';
      this.progressDirec2 = this.objCliente.direc2.length + '%';

      this.clases = response.body.clases;
      if (this.clases.find(x => x.clase == 14) == null) {
        this.Ubigeobloc = false;
      }
      else {
        this.Ubigeobloc = true;
      }

      this.condicionesPago = response.body.condicionespago;
      this.contactos = response.body.contactos;
      this.especificaciones = response.body.especificaciones;
      this.direcciones = response.body.direccionesenvio;
      this.bancos = response.body.bancos;


      this.buscarLimpiarBoton = 'borrar';
      this.dataService.vista = 1;
      this.dataService.tipo = 'cliente';

      this.disabledCliente = true;
      this.mostrarTab = false;
      this.flagDisabledButtons = false;
      this.selectModalNuevo();

      setTimeout(() => {
        $('#cboTipoPersona').focus();
      }, 150);

      this.onSelectTipoPersonaIns(this.objCliente.codtpe);

      this.onNexFocus('Insert')
      this.onSelectTipoIdentidadIns(this.objCliente.tident)

    }, err => {
      this.spinnerService.activarLoading(false);
      /* if (err.status == 404) {
        basicAlert('Cliente no encontrado', 'warning', 'Aceptar');
      } */
      setTimeout(() => {
        //this.chRef.detectChanges();
        //this.funicionesTSIService.createTable('datatableContacto', false, true, '350px');
        //this.funicionesTSIService.createTable('datatableBancos', false, true, '350px');
        //this.funicionesTSIService.createTable('datatableDireccionesEnvio', false, true, '350px');
      }, 350);
    });

  }

  tipobusqueda = '0'
  razoncsearch
  nombressearch

  onChangeRadioButron() {
    if (this.tipobusqueda == '0') {
      this.nombressearch =  this.objCliente.razonc + "%";
      this.razoncsearch = ''
    } else {
      this.razoncsearch =  this.objCliente.razonc + "%";
      this.nombressearch = ''
    }
  }

  openModalInterlocutor() {
    //this.onChangeRadioButron()
    let codcli: string = '';
    let razonc: string = this.objCliente.razonc + "%";
    let nombres: string = this.objCliente.razonc + "%";
    let dident: string = '';
    let soloactivos: boolean = false;
    let limit: number = 350;
    let offset: number = 0;

    this.ParamDocumento.razonc = this.objCliente.razonc;

    if (this.objCliente.razonc.length > 0) {
      this.spinnerService.activarLoading(true);

      //this.funicionesTSIService.destroyTable('ModaldatatableInterlocutor');
      this.interlocutorService.buscarInterlocutor(codcli, razonc, nombres, dident, soloactivos, limit, offset).subscribe((response: any) => {
        this.interlocutores = response.body;
        this.mostrarModalInterlocutor();

      }, err => {
        if (err.status == 404) {
          basicAlert('No se encontró la lista de clientes', 'warning', 'Aceptar', null, null, this.razon);
        }
        this.spinnerService.activarLoading(false);
      });
    } else {
      basicAlert('Para activar la ayuda ingresar mínimo 1 caracter', 'warning', 'Aceptar', null, null, this.razon);
      return;
    }
  }

  mostrarModalInterlocutor() {
    const referenciaModal = this.modalService.open(ModalBusquedaInterlocutorComponent, { scrollable: true, windowClass: 'modal-lg-mytheme', backdrop: 'static' });
    referenciaModal.componentInstance.cabeceraTexto = 'comercial'
    referenciaModal.componentInstance.interlocutores = this.interlocutores;
    referenciaModal.componentInstance.interlocutores_temp = this.interlocutores;
    referenciaModal.componentInstance.cabeceraTipo = this.tipobusqueda
    //referenciaModal.componentInstance.interlocutores = this.interlocutores;
    referenciaModal.componentInstance.razonsocialBusqueda = '';
    //referenciaModal.componentInstance.nombresBusqueda =  this.cotizacionmodel.desInterlocutor;
   
    referenciaModal.result.then((data) => {

      this.getByCodInterlocutor(data.codcli,1);

    }, (reason) => {
      console.log(reason);
    });
  }
  //Predeterminado
  onChangePredeterminado(isChecked: boolean) {
    if (isChecked) {
      this.predeterminado = true;
    } else {
      this.predeterminado = false;
    }
  }
  //ACtivo
  onChangeActivo(isChecked: boolean) {
    if (isChecked) {
      this.activo = true;
    } else {
      this.activo = false;
    }
  }




  borrarDatosInterlocutor() {
    this.disabledInterlocutor = false;
    this.encontro = true;

    this.objCliente = new objClienteFrm();
    this.objCliente.fecing = moment(new Date()).format("YYYY-MM-DD");
    this.buscarLimpiarBoton = 'buscar';
    this.dataService.vista = 0;

    this.disabledCliente = false;
    this.interlocutores = [];
    this.clases = [];
    this.condicionesPago = [];
    this.especificaciones = [];
    this.contactos = [];

    this.direcciones = [];
    /*this.creditos = [];
    
    this.contactos = [];
    this.bancos = [];
    this.contactosAsignados = [];
    this.especificaciones = [];
    this.direccionesEnvio = [];
    */
    this.mostrarTab = true;
    this.flagDisabledButtons = true;


    this.tabModificar = false;
    this.tabClases = true;
    this.tabCondicionesPago = true;
    this.tabCreditos = true;
    this.tabContactos = true;
    this.tabEspecificaciones = true;
    this.tabDireccionesEnvio = true;
    //this.botonUbigueo = false;

    $("#modificar-tab").addClass("active");
    $("#clases-tab").removeClass("active");
    $("#codpago-tab").removeClass("active");
    $("#creditos-tab").removeClass("active");
    $("#contacto-tab").removeClass("active");
    $("#especificacion-tab").removeClass("active");
    $("#direnvio-tab").removeClass("active");
    $("#banco-tab").removeClass("active");
    $('#datatableBancos').DataTable().destroy();
    setTimeout(() => {
      $('#desInterlocutor').focus();
    }, 250);

    this.cancelarInsercion();

  }

  onSelectTipoPersonaIns(codTpe: number) {

    if (codTpe == 1) {
      this.tident = "06"
    } else {
      this.tident = "999999"
    }
  }

  open1(content1: string) {

    this.open(content1)

    // this.modalService.open(content1, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
    //   this.closeResult = `Closed with: ${result}`;
    // }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // });
  }

  nuevoDireccionEnvio() {
    const referenciaModal = this.modalService.open(ModalDireccionEnvioComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.componentInstance.editar = false;
    referenciaModal.componentInstance.codcli = this.objCliente.codcli;
    referenciaModal.result.then((data) => {
      console.log("view info success ")
      console.log(data);

      this.direcciones = [];
      this.spinnerService.activarLoading(true);
      this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        this.direcciones = response.body.direccionesenvio;
        console.log(this.direcciones);
      }, err => {
        this.spinnerService.activarLoading(false);
      });
    }, (reason) => {
      console.log(reason);
    });
  }

  // AbrirModificarDirecciones(content10 , item)
  editarDireccionEnvio(item: any) {
      this.spinnerService.activarLoading(true);
      this.interlocutorService.direccion_envio_obtener(this.objCliente.codcli, item.codenv).subscribe((resp: any) => {
        this.spinnerService.activarLoading(false);
  
        console.log(resp)
  
        const referenciaModal = this.modalService.open(ModalDireccionEnvioComponent, { backdrop: 'static', size: 'lg' });
        referenciaModal.componentInstance.editar = true;
        referenciaModal.componentInstance.codcli = this.objCliente.codcli;
        referenciaModal.componentInstance.DireccionTemp = resp.body;
        referenciaModal.result.then((data: any) => {
  
          console.log("view info success ")
          console.log(data);
  
          this.direcciones = [];
          this.spinnerService.activarLoading(true);
          this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            this.direcciones = response.body.direccionesenvio;
            console.log(this.direcciones);
          }, err => {
            this.spinnerService.activarLoading(false);
          });
        }, (reason) => {
          console.log(reason);
        });
  
      }, err => {
        this.spinnerService.activarLoading(false);
  
      })
  }
  modal : NgbModalRef;

  open(content) {
    this.modal = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg'})    
    this.modal.result.then((e) => {
        console.log("dialogo cerrado")
    });        
  }

  open2(content2: string, item: any) {
    if (item.clase == 14 || item.clase == 15 || item.clase == 16) {
      this.editUbigeo();
    } else {
      this.disabledCodigosClaseCombo = false;
      this.listacodigos = [];
      this.codCodigoClase = null;

      this.obtenerListaClasesCodigos(item.clase);


      this.editinputcla = item.clase;
      this.editinputdescla = item.desclase;
      this.editinputcodigo = item.codigo;
      this.editinputdescodigo = item.descodigo;

      this.editclase = item;

      this.open(content2)
      return;
    }



  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === 1) {
      return 'by pressing ESC';
    } else if (reason === 0) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  //Guardar Clase
  guardarClase() {


    if (this.codClase != null && this.codCodigoClase != null) {

      this.ClaseTemp = new ClienteClase();
      this.ClaseTemp.clase = this.codClase;
      this.listaclases.forEach(element => {
        if (element.codigo == this.codClase) {
          this.desClase = element.descri;
        }
      });
      this.ClaseTemp.desclase = this.desClase;

      //Para saber si no existe
      if (this.clases.find(x => x.clase == this.ClaseTemp.clase) != null)
        basicAlert('El código de clase ya existe.', 'warning', 'Aceptar', null, null);


      //obteniendo la descripcion del codigo en desCodigoClase
      this.listacodigos.forEach(element => {
        if (element.codigo == this.codCodigoClase) {
          this.desCodigoClase = element.descri;
        }
      });

      //this.ClaseTemp.codmot =this.inputclase;
      this.ClaseTemp.codigo = this.codCodigoClase;
      this.ClaseTemp.descodigo = this.desCodigoClase;

      if (this.ClaseTemp.clase == 14) {
        this.Ubigeobloc = true;
      } else {
        this.Ubigeobloc = false;
      }

      this.clases.push(this.ClaseTemp);

      this.clases = [...this.clases]
      if (this.clases.find(x => x.clase == 14) == null) {
        this.Ubigeobloc = false;
      } else {
        this.Ubigeobloc = true;
      }

      this.modal.close();
      this.tableclases = this.clases;
      this.codClase = null;
      this.desClase = '';
      this.codCodigoClase = null;
      this.desCodigoClase = '';
      this.ClaseTemp = new ClienteClase();
      this.borrarDatosInset();
    } else {
      //En caso no se llenen los datos necesarios
      var dato = ''
      if (this.codClase == null) {
        dato = '"Clase"'
      } else if (this.codCodigoClase == null) {
        dato = '"Código"'
      }
      basicAlert("El campo " + dato + "es obligatorio.", 'warning', 'Aceptar');

    }


  }

  borrarDatosInset() {
    //this.disabledBotonClases = true;
    this.disabledCodigosClaseCombo = true;
    this.codClase = null;
    this.desClase = '';
    this.codCodigoClase = null;
    this.desCodigoClase = '';
    //DIRECCION ENVíO
    this.codEnvio = null;
    this.desEnvio = '';
    this.direccionE1 = '';
    this.referenciaEnvio = '';
    this.telefonoEnvio = '';
    this.codEanEnvio = '';
    this.celularEnvio = '';
    //BANCos
    this.disabledTipoCuenta = true;
    this.disabledMoneda = true;
    this.disabledBotonBanco = true;


    //this.childModalClases.hide();
  }
  closeInsert() {
    this.borrarDatosInset();
    this.tipoConfirmar = 'Insert';
  }

  //Actualizar Clase
  guardarActualizarClase() {

    this.sessionInfo = JSON.parse(StorageService.getSession());
    console.log(this.sessionInfo)
    let arreglo = this.clases;
    let indice = arreglo.indexOf(this.editclase);

    arreglo[indice].clase = this.editinputcla;
    //
    this.listaclases.forEach(element => {
      if (element.codigo == this.editinputcla) {
        this.editinputdescla = element.descri;
      }
    });
    //  
    arreglo[indice].desclase = this.editinputdescla;

    arreglo[indice].codigo = this.editinputcodigo;
    //
    this.listacodigos.forEach(element => {
      if (element.codigo == this.editinputcodigo) {
        console.log(element)
        this.editinputdescodigo = element.descri;
      }
    });
    //
    arreglo[indice].descodigo = this.editinputdescodigo;


    this.clases = arreglo
    basicAlert('Se actualizó con éxito.', 'success', 'Aceptar', null, null);
    this.modal.close();
  }

  //Almacenar cond. pago
  nuevaCondicionPago() {
    this.sessionInfo = JSON.parse(StorageService.getSession());
    if (this.codCondicionPago == null) {
      basicAlert("El campo 'Condicion de pago' es obligatorio.", 'warning', 'Aceptar');
      return;
    }

    //obteniendo la descripcion del codigo en codpag
    //Cambiar lista y los datos de element
    this.listacondpago.forEach(element => {
      if (element.codpag == this.codCondicionPago) {
        this.desCondicionPago = element.despag;
      }
    });
    console.log("this.CondicionTemp.predeterminado")
    console.log(this.predeterminado)

    if(this.predeterminado == true){
      this.condicionesPago.forEach(element => {
        if (element.predeterminado == true) {
          element.predeterminado = false;
        }
      });
    }

    this.CondicionTemp = new CondicionesPago();
    this.CondicionTemp.codpag = this.codCondicionPago;
    if (this.condicionesPago.find(x => x.codpag == this.CondicionTemp.codpag) == null) {
      if (this.sessionInfo != null) {
        this.CondicionTemp.usuari = this.sessionInfo.coduser;
      }
      this.CondicionTemp.despag = this.desCondicionPago;
      this.CondicionTemp.activo = this.activo;
      this.CondicionTemp.predeterminado = this.predeterminado;
      this.CondicionTemp.esNuevo = true;
      // this.CondicionTemp.usuario =this.sessionInfo.coduser,
      //this.response.emit(this.objInterlocutor);
      this.condicionesPago.push(this.CondicionTemp);

    } else {
      basicAlert('El código ya existe.', 'warning', 'Aceptar', null, null);
      return;
    }


    this.condicionesPago = [...this.condicionesPago]
    this.modal.close();

    this.tablecondi = this.condicionesPago;

    this.codCondicionPago = null;
    this.desCondicionPago = '';
    this.activo=true;
    this.predeterminado = null;
    this.CondicionTemp = new CondicionesPago();
    this.borrarDatosInset();
  }

  onChangeActivoUpd(isChecked: boolean) {
    if (isChecked) {
      this.activoUpd = true;
    } else {
      this.activoUpd = false;

    }
  }

  onChangePredeterminadoUpd(isChecked: boolean) {
    if (isChecked) {
      this.predeterminadoUpd = true;
    } else {
      this.predeterminadoUpd = false;
    }
  }

  open4(content4: string, cla: any) {



    this.codCondicionPagoUpd = cla.codpag;
    this.desCondicionPagoUpd = cla.despag;
    //this.obtenerListaClasesCodigos(cla.clase);
    this.predeterminadoUpd = cla.predeterminado;
    this.activoUpd = cla.activo;
    this.editcond = cla;
    this.open(content4)

    // this.modalService.open(content4, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
    //   this.closeResult = `Closed with: ${result}`;
    // }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // });
    return;
  }

  guardarActualizarCondicion() {

    console.log("this.CondicionTemp.predeterminado")
    console.log(this.predeterminado)

    if(this.predeterminadoUpd == true){
      this.condicionesPago.forEach(element => {
        if (element.predeterminado == true) {
          element.predeterminado = false;
        }
      });
    }
    
    let arreglocond = this.condicionesPago;
    let indice = arreglocond.indexOf(this.editcond)

    arreglocond[indice].codpag = this.codCondicionPagoUpd;
    //
    this.listaclases.forEach(element => {
      if (element.codigo == this.codCondicionPagoUpd) {
        this.desCondicionPagoUpd = element.descri;
      }
    });
    //  
    arreglocond[indice].despag = this.desCondicionPagoUpd;
    arreglocond[indice].predeterminado = this.predeterminadoUpd;
    arreglocond[indice].activo = this.activoUpd;

    this.condicionesPago = arreglocond
    // basicAlert('Se actualizo con éxito.', 'success', 'Aceptar', null, null);
    this.modal.close();
  }


  _mNuevoContacto() {
    const referenciaModal = this.modalService.open(ContactoFrmComponent, { size: 'lg', backdrop: 'static' });
    referenciaModal.componentInstance.editar = false;
    referenciaModal.result.then((data) => {
      console.log("view info success ")
      console.log(data);
      this.insertAsignarContacto(data.codcont);
    }, (reason) => {
      console.log(reason);
    });
  }

  _mEditarContacto(item: any) {

    let _contact: any = {};
    _contact.codcont = item.codcont;
    _contact.nomcont = item.nomcont;
    _contact.direccion = item.direccion;
    _contact.hobby = item.hobby;
    _contact.telefono = item.telefono;
    _contact.activo = item.activo;
    _contact.palabraclave = item.palabraclave;
    _contact.email = item.correo;
    _contact.cargo = item.cargo;
    _contact.observacion = item.observacion;

    const referenciaModal = this.modalService.open(ContactoFrmComponent, { size: 'lg', backdrop: 'static' });
    referenciaModal.componentInstance.editar = true;
    referenciaModal.componentInstance.contacto = _contact;
    referenciaModal.componentInstance.codInterlocutor = this.objCliente.codcli;
    referenciaModal.result.then((data) => {
      if (data.actualizado != undefined && data.actualizado != null && data.actualizado) {
        this.contactos = [];
        this.spinnerService.activarLoading(true);
        this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          this.contactos = response.body.contactos;
        }, err => {
          this.spinnerService.activarLoading(false);
          console.log(err);
        });
      }
    }, (reason) => {
      console.log(reason);
    });
  }

  insertAsignarContacto(codcont: number) {
    this.spinnerService.activarLoading(true);
    this.interlocutorService.insertContactoInterlocutor(this.objCliente.codcli, codcont).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.borrarDatosInset();
      //this.response.emit();
      basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);
      this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
        this.contactos = response.body.contactos;
      }, err => {
        this.spinnerService.activarLoading(false);
        if (err.status == 404) {
          basicAlert(err.error, 'warning', 'Aceptar');
        }
      });

    }, err => {
      this.spinnerService.activarLoading(false);
      if (err.status == 404) {

        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
      } if (err.status == 400) {

        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
        this.spinnerService.activarLoading(false);
      } if (err.status == 500) {

        basicAlert('Error en el servicio, por favor comuniquese con el administrador del sistema', 'warning', 'Aceptar', null, null,);
        this.spinnerService.activarLoading(false);
      }
    });
  }

  importarDatosSunat() {

    const referenciaModal = this.modalService.open(ImportarSunatComponent, { scrollable: true, backdrop: 'static', windowClass: 'md-importar-sunat'});
    referenciaModal.componentInstance.objImageSunat = this._sunatImage;
    referenciaModal.componentInstance.ruc = this.objCliente.dident;
    referenciaModal.result.then((data) => {
      console.log("se importo")
      console.log(data);

      this.objCliente.codtpe = 2;
      this.objCliente.tident = '06';
      this.objCliente.dident = data.ruc;
      this.objCliente.direc1 = data.direc;
      this.objCliente.razonc = data.razonc;
      this.onSelectTipoIdentidadIns(this.objCliente.tident)


      this.getByCodInterlocutor(this.objCliente.dident,2);

    }, (reason) => {
      console.log("reason");
      console.log(reason);
    });



  }





  onChangeFinanciera() {
    this.disabledTipoCuenta = false;
  }

  onChangeTipoCuenta() {
    this.disabledMoneda = false;
    this.disabledBotonBanco = false;
  }


  //------------------ SECCIÓN DE ELIMINAR -------------------/// 
  EliminarClase(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar registro?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {

          this.spinnerService.activarLoading(true);
          this.clienteService.eliminarClase(this.objCliente.codcli, data.clase).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.clases = [];
            this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {

              this.clases = response.body.clases;
              if (this.clases.find(x => x.clase == 14) == null) {
                this.Ubigeobloc = false;
              } else {
                this.Ubigeobloc = true;
              }

            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });

          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });
        }
      })
  }

  EliminarCodPago(data: any) {

    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert: any) => {

        console.log(responseAlert);

        if (responseAlert != undefined && responseAlert != null && responseAlert) {

          if (data.esNuevo != null && data.esNuevo) {

            let _condiciones: any = this.condicionesPago.filter(x => x.codpag != data.codpag);
            if (_condiciones != null) {

              console.log(_condiciones);


              this.condicionesPago = _condiciones;
            }

          } else {
            this.spinnerService.activarLoading(true);
            this.clienteService.eliminar_codpag(this.objCliente.codcli, data.codpag)
              .subscribe((response: any) => {
                this.spinnerService.activarLoading(false);
                basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
                this.condicionesPago = [];
                this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
                  this.condicionesPago = response.body.condicionespago;
                }, err => {
                  this.spinnerService.activarLoading(false);
                  console.log(err);
                });
              }, err => {
                this.spinnerService.activarLoading(false);
                console.log(err.error.mensaje);
                basicAlert(err.error, 'success', 'Aceptar');
              });

          }



          // this.condicionesPago = [...this.condicionesPago]


        }
        this.modal.close();
      })
  }

  EliminarContacto(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {


        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          this.spinnerService.activarLoading(true);
          this.clienteService.eliminar_contacto(this.objCliente.codcli, data.codcont).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.contactos = [];
            this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
              this.contactos = response.body.contactos;
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });
          this.contactos = [...this.contactos]
        }
        this.modal.close();;

      })
  }

  EliminarEspecificacion(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          this.spinnerService.activarLoading(true);
          this.clienteService.eliminar_especificacion(this.objCliente.codcli, data.codesp).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.especificaciones = [];
            this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
              this.especificaciones = response.body.especificaciones;
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
            this.selectModalNuevo();
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });
          this.especificaciones = [...this.especificaciones]
        }



        this.modal.close();;
      })
  }

  EliminarDireccion(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          this.spinnerService.activarLoading(true);
          this.clienteService.eliminar_direcciones_envio(this.objCliente.codcli, data.codenv).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.direcciones = [];
            this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
              this.direcciones = response.body.direccionesenvio;
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });
          this.direcciones = [...this.direcciones]
        }


        this.modal.close();;
      })
  }

  EliminarBanco(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          this.spinnerService.activarLoading(true);
          this.clienteService.eliminar_bancos(this.objCliente.codcli, data.codban, data.tipcta, data.tipmon).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.bancos = [];
            this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
              this.bancos = response.body.bancos;
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'warning', 'Aceptar');
          });
          this.bancos = [...this.bancos]
        }


        this.modal.close();;
      })
  }
  ///////////////////////////////////////////////////////////////



  onCLickEspecificacion(data: any) {
    this.tipoConfirmar = 'InsertEspecificacion';
    console.log(data);
    this.codEspecificacion = data.codigo;
    this.desEspecificacion = data.descri;
    this.disabledDecimal = data.vreal;
    this.disabledTexto = data.vstrg;
    this.disabledCaracter = data.vchar;
    this.disabledFecha = data.vdate;
    this.disabledTiempo = data.vtime;
    this.disabledNumero = data.ventero;
  }

  guardarEspecificacion() {


    this.especificacion.forEach(element => {
      if (element.codigo == this.codEspecificacion) {
        console.log(element)
        this.desEspecificacion = element.descri;
      }
    });

    this.EspecifiacionTemp = new ClienteEspecificaciones();
    this.EspecifiacionTemp.codesp = this.codEspecificacion;
    this.EspecifiacionTemp.descri = this.desEspecificacion;

    this.EspecifiacionTemp.vreal = this.decimal;
    this.EspecifiacionTemp.vstrg = this.texto;
    this.EspecifiacionTemp.vchar = this.caracter;
    this.EspecifiacionTemp.vdate = this.fecha != '' ? moment(this.fecha).format("YYYY-MM-DD") : '';
    this.EspecifiacionTemp.vtime = this.tiempo;
    this.EspecifiacionTemp.ventero = this.numero;

    this.especificaciones.push(this.EspecifiacionTemp);
    this.especificaciones = [...this.especificaciones]
    this.modal.close();
    console.log("Especificacion temporal a guardar")
    this.tableespecificaciones = this.especificaciones;
    console.log(this.EspecifiacionTemp)

    this.codEspecificacion = null;
    this.desEspecificacion = null;
    this.decimal = null;
    this.texto = null;
    this.caracter = null;
    this.tiempo = null;
    this.numero = null;

    this.tipoConfirmar = 'Insert';

    new ClienteEspecificaciones();
    this.borrarDatosInset();
    this.selectModalNuevo();
  }
  actualizarLista:boolean=false;
  eliminarCliente() {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {
        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          if (this.objCliente != null && this.objCliente.codcli != null) {
            this.spinnerService.activarLoading(true);
            this.clienteService.eliminar(this.objCliente.codcli).subscribe((resp: any) => {
              this.spinnerService.activarLoading(false);
              this.actualizarLista=true;
              this.toastr.success('Se eliminó correctamente.','',{ positionClass: 'toast-bottom-left'})
              this.borrarDatos();
              this.buscarLimpiarBoton = 'buscar';
              this.dataService.vista = 0;

              this.mostrar = false;
              this.ParamDocumento = new Cliente();
              this.vista = 1;
              this.cerrar()

            }, err => {
              this.spinnerService.activarLoading(false);
              basicAlert(err.error, 'warning', 'Aceptar', null, null);
            })
          }
        }
        this.modal.close();
      })
  }

  guardarBanco() {
    if (this.codBanco == null) {
      basicAlert("El campo 'Financiera' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    if (this.codTipoCuenta == null) {
      basicAlert("El campo 'Tipo cuenta' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    if (this.codMoneda == '') {
      basicAlert("El campo 'Moneda' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    if (this.desCuenta == '') {
      basicAlert("El campo 'N° cuenta' es obligatorio.", 'warning', 'Aceptar');
      return;
    }

    this.BancoTemp = new ClienteBancos();
    this.BancoTemp.codban = this.codBanco;
    this.financieras.forEach(element => {
      if (element.codigo == this.codBanco) {
        console.log(element)
        this.desBanco = element.descri;
      }
    });
    this.BancoTemp.desban = this.desBanco;


    /////////////////////////////////////////////
    this.BancoTemp.tipcta = this.codTipoCuenta;
    this.tipocuentas.forEach(element => {
      if (element.codigo == this.codTipoCuenta) {
        console.log(element)
        this.desTipoCuenta = element.descri;
      }
    });
    this.BancoTemp.descta = this.desTipoCuenta;
    this.BancoTemp.tipmon = this.codMoneda;
    this.BancoTemp.cuenta = this.desCuenta;

    this.spinnerService.activarLoading(true);
    this.clienteService.insertar_bancos(this.objCliente.codcli, this.BancoTemp).subscribe((response: any) => {
      basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);
      console.log(response);
      this.spinnerService.activarLoading(false);

      this.codBanco = null;
      this.desBanco = '';
      this.codTipoCuenta = null;
      this.desTipoCuenta = null;
      this.codMoneda = '';
      this.desCuenta = null;


      this.bancos = [...this.bancos]
      this.modal.close();
      console.log("Clase temporal a guardar")
      this.tablebancos = this.bancos;
      this.BancoTemp = new ClienteBancos();
      this.borrarDatosInset();

      this.spinnerService.activarLoading(true);
      this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        this.bancos = response.body.bancos;
        console.log(this.bancos);
      }, err => {
        this.spinnerService.activarLoading(false);
        console.log(err);
        if (err.status == 404) {
          basicAlert('Cliente no encontrado', 'warning', 'Aceptar');
        }
      });
    }, err => {
      this.spinnerService.activarLoading(false);
      if (err.status == 500) {
        basicAlert('Servicio no disponible, por favor comuniquese con el administrador del sistema', 'warning', 'Aceptar', null, null,);
      } else {
        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
      }
    })



  }




  AbrirModificarEspecificacion(content6: string, cla: any) {
    console.log("Especificación que se modificara")
    console.log(cla)

    this.disabledDecimalUpd = false;
    this.disabledTextoUpd = false;
    this.disabledCaracterUpd = false;
    this.disabledFechaUpd = false;
    this.disabledTiempoUpd = false;
    this.disabledNumeroUpd = false;
    //this.obtenerListaClasesCodigos(cla.clase);
    this.desEspecificacionUpd = cla.descri
    this.decimalUpd = cla.vreal;
    this.textoUpd = cla.vstrg;
    this.caracterUpd = cla.vchar;
    this.fechaUpd = cla.vdate;
    this.tiempoUpd = cla.vtime;
    this.numeroUpd = cla.ventero;

    if (cla.vreal != null) {
      this.disabledDecimalUpd = true;
    }
    if (cla.vstrg != null) {
      this.disabledTextoUpd = true;
    }
    if (cla.vchar != null) {
      this.disabledCaracterUpd = true;
    }
    if (cla.vtime != null) {
      this.disabledTiempoUpd = true;
    }
    if (cla.ventero != null) {
      this.disabledNumeroUpd = true;
    }

    this.editespecificacion = cla;


    this.modalService.open(content6, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    return;
  }



  AbrirModificarBanco(content: string, cla: any) {
    console.log("Dirección que se modificara")
    console.log(cla)

    //this.obtenerListaClasesCodigos(cla.clase);
    this.codBancoUpd = cla.codban;
    this.desBancoUpd = cla.desban;
    this.codTipoCuentaUpd = cla.tipcta;
    this.desTipoCuentaUpd = cla.descta;
    this.codMonedaUpd = cla.tipmon;
    //this.desMonedaUpd = cla.ventero;
    this.desCuentaUpd = cla.cuenta;

    this.editbanco = cla;

    this.open(content)

    return;
  }

  ModificarEspecificacion() {
    console.log(this.especificaciones)
    let arreglo = this.especificaciones;
    let indice = arreglo.indexOf(this.editespecificacion)

    console.log(indice)

    arreglo[indice].vreal = this.decimalUpd;
    arreglo[indice].vstrg = this.textoUpd;
    arreglo[indice].vchar = this.caracterUpd;
    arreglo[indice].vdate = this.fechaUpd;
    arreglo[indice].vtime = this.tiempoUpd;
    arreglo[indice].ventero = this.numeroUpd;


    console.log("Especificaciones modificado");
    console.log(arreglo)
    this.especificaciones = arreglo
    basicAlert('Se actualizó con éxito.', 'success', 'Aceptar', null, null);
    this.modal.close();
  }

  decimalFormatLimiteCredito(dato: any) {
    this.ConvertNumero(dato)
    // let lengthtext: any = +this.decimalPrecio + 4
    // if (dato.length > lengthtext) {
    //   let datoreplace = dato.replace(',', '')
      
    //   this.objCliente.limiteCredito = parseFloat(datoreplace);
    // } else {
    //   this.objCliente.limiteCredito = parseFloat(dato);
    // }
    // this.viewlimiteCredito = this.decimalPipe.transform(this.objCliente.limiteCredito, `0.${this.decimalPrecio}-${this.decimalPrecio}`);
  }

  ConvertNumero(data: any){
    let valorreplace: string = '';
    let valor: number = 0;  
    valorreplace = data;
    console.log("valorreplace traido")
    console.log(valorreplace)

      do{
        if (valorreplace.includes(',')) {
          valorreplace = valorreplace.replace(',', '')
          // valor = parseFloat(valorreplace);
          console.log("valorreplace traido1")
          console.log(valorreplace)
          this.objCliente.limiteCredito = valorreplace

        } else {
          valorreplace = valorreplace
          this.objCliente.limiteCredito = valorreplace
          console.log("valorreplace traido2")
          console.log(valorreplace)
        }
      }while(valorreplace.includes(','));
    
    this.objCliente.limiteCredito = Number(this.objCliente.limiteCredito)
    console.log(this.objCliente.limiteCredito)

    this.viewlimiteCredito = this.decimalPipe.transform(this.objCliente.limiteCredito, `0.${this.decimalPrecio}-${this.decimalPrecio}`);
    console.log(this.viewlimiteCredito)
  }


  modificarBanco() {
    let bancomod: ClienteBancos = {

      codban: this.codBancoUpd,
      desban: this.desBancoUpd,
      tipcta: this.codTipoCuentaUpd,
      descta: this.desTipoCuentaUpd,
      tipmon: this.codMonedaUpd,
      cuenta: this.desCuentaUpd,
      id_cia: null,
    }

    this.spinnerService.activarLoading(true);
    this.clienteService.actualizar_bancos(this.objCliente.codcli, bancomod).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      basicAlert('Se modificó con éxito.', 'success', 'Aceptar', null, null);
      this.bancos = [];
      this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
        this.bancos = response.body.bancos;
      }, err => {
        this.spinnerService.activarLoading(false);
        console.log(err);
      });
    }, err => {
      this.spinnerService.activarLoading(false);
      console.log(err.error.mensaje);
      basicAlert(err.error, 'warning', 'Aceptar');
    });
    this.bancos = [...this.bancos]
    this.modal.close();

  }

  selectModalNuevo() {
    this.interlocutorService.getEspecificaciones().subscribe(response => {
      let espec = response.body;
      this.especificaciones.forEach(element => {
        espec = espec.filter(function (dato) {
          if (dato.codigo == element.codesp) {
            return false;
          } else {
            return true;
          }
        });
      });
      console.log('ARREGLO FINAL SELECT:')
      console.log(espec);
      this.especificacion = espec;
    })
  }
  @ViewChild('dident') dident: ElementRef;

  onSelectTipoIdentidadIns(tipid: string) {
    //evaluando tipo de identidad
    console.log("evaluando tipo de identidad");
    console.log(tipid);
    if (tipid == "01") {
      this.identidad = false
      this.isnatural = false
    } else {
      this.identidad = true
      this.isnatural = true
      this.objCliente.nrodni = null
      this.objCliente.nrodni = ""
    }
    this.identidades.forEach(element => {
      if (element.tident == tipid) {
        console.log(element)
        this.tamanoidentidad = element.tamano;
      }
    });
    console.log("this.tamanoidentidad");
    console.log(this.tamanoidentidad);


    timerOut(50).then((value: any) => {
      if (value) { this.dident.nativeElement.focus(); }
    })
  }

  onKeyUpNombresCompletos(event: any) {

    this.quitarEspaciosEnBlanco(event.target.value);
    console.log(event.target.value);
    let separacion = event.target.value.replace("  ", " ")

    let NOMBRES = separacion.split(" ");

    if (separacion == '') {
      NOMBRES = [];
    }

    if (NOMBRES.length == 0) {
      this.objCliente.nombres = '';
      this.objCliente.apellidopaterno = '';
      this.objCliente.apeliidomaterno = '';
    }

    if (NOMBRES.length == 1) {
      this.objCliente.apellidopaterno = '';
      this.objCliente.apeliidomaterno = '';
      this.objCliente.nombres = NOMBRES[0];
    }

    if (NOMBRES.length == 2) {
      this.objCliente.apeliidomaterno = '';
      this.objCliente.apellidopaterno = NOMBRES[0];
      this.objCliente.nombres = NOMBRES[1];
    }

    if (NOMBRES.length == 3) {
      this.objCliente.apellidopaterno = NOMBRES[0];
      this.objCliente.apeliidomaterno = NOMBRES[1];
      this.objCliente.nombres = NOMBRES[2];
    }

    if (NOMBRES.length == 4) {
      this.objCliente.apellidopaterno = NOMBRES[0];
      this.objCliente.apeliidomaterno = NOMBRES[1];
      this.objCliente.nombres = NOMBRES[2] + ' ' + NOMBRES[3];
    }
  }
  quitarEspaciosEnBlanco(cadena: string) {
    let espaciosVacios: number = 0;
    for (let index = 0; index < cadena.length; index++) {
      const element = cadena[0];
      if (element == ' ') {
        espaciosVacios = 1;
      }
    }
    //nombresyapellidos
    this.objCliente.razonc = cadena.replace(cadena.substring(0, espaciosVacios), '');
    if (cadena.includes('  ')) {
      this.objCliente.razonc = cadena.replace('  ', ' ')
    }
  }
  onBlurDocIdentidad() {
    console.log("this.objCliente.dident.length")
    console.log(this.objCliente.dident.toString().length)

  }

  cerrar(){
    this.modalService2.close(this.actualizarLista);
  }
  /**Docuemntos Adjuntos */
  onInputClick(e) {
    e.target.value = '';
  }
  fileToUpload: FileList = null;
fileName: string = '';
  handleFileInput(files: FileList) {
    this.spinnerService.activarLoading(true);
    console.log("cantidad de archivos")
    console.log(files.length)
    console.log(files)
    this.fileToUpload = files;
    this.fileName = files.item(0).name;
  
    for (let i = 0; i < files.length; i++) {
      console.log("loop")
      console.log(files.item(i))
      this.readThisAdjunto(files.item(i))
    }
    this.spinnerService.activarLoading(false);
  }
  public base64convertido: any;
  nombrearchivo
  public formato: string;
  public size: number;
  public disabledbotonImagen: boolean = true;
  readThisAdjunto(inputValue: any): void {
    let imageBase64;
    var file: File = inputValue;
    var myReader: FileReader = new FileReader();
  
    console.log(file);
    myReader.onloadend = (e) => {
      imageBase64 = myReader.result;
      this.base64convertido = imageBase64.replace("data:"+file.type+";base64,", "");
        this.formato = file.type;
        this.size = file.size;
        this.nombrearchivo = file.name;
         
          this.disabledbotonImagen = false;
    
            let obj: any = {
              //tipinv: this.tipinv, 
             // codart: this.codart,
              id_cia: this.sessionInfo.id_cia,
              codcli:  this.objCliente.codcli,
              razonc:  this.objCliente.razonc,
              base64:  this.base64convertido,
              formato: this.formato,
              nombre: this.nombrearchivo,
              tipcli: 'A',
            }
            console.log("insertando obj:")
            console.log(obj)
            this.agregarAdjunto1(obj);
    }
    myReader.readAsDataURL(file);

  }
  agregarAdjunto1(obj) {
    this.spinnerService.activarLoading(true);

    this.clienteService.insertarAdjuntoCliente(obj).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.getAdjuntos();
    }, err => {
      if (err.status == 404) {
        console.log(err);
        this.spinnerService.activarLoading(false);
        basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
      }
      else
        this.spinnerService.activarLoading(false);
      basicAlert(err.error, 'warning', 'Aceptar', null, null, null);

    })
  }
  doc_adjuntos:any[]=[];
  getAdjuntos(){
    //FALTA CORREGIR
    this.spinnerService.activarLoading(true);
    this.clienteService.obtenerAdjuntoCliente(this.codcli, 'A').subscribe((response: any) => {
      console.log('Obteniendo Adjuntos',response.body); 
      this.doc_adjuntos = response.body.map(objeto => ({
        ...objeto, // Copiamos todas las propiedades originales
        obs: objeto.observ // Agregamos el nuevo campo
      }));
      this.spinnerService.activarLoading(false);
    }, err => {
      if (err.status == 404) {
        this.spinnerService.activarLoading(false);
        console.log(err);
        this.doc_adjuntos = [];
        // basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
      }
    })
  }
  eliminarAdj(data){
    this.spinnerService.activarLoading(true);
    this.clienteService.deleteAdjuntoCliente(data.codcli, 'A', data.id).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log("-------- ADJUNTOS ------");
      console.log(response)
      this.getAdjuntos();
      this.toastr.success('Se eliminó correctamente.','',{ positionClass: 'toast-bottom-left'});
    }, err => {
      basicAlert(`Error`, 'warning', 'Aceptar');
      this.spinnerService.activarLoading(false);
    });
  
  }
  actualizar(data:any){
    timerOut(500).then((value: any) => {
      console.log('actualizando data: ',data);
      data.id_cia=this.sessionInfo.id_cia;
      data.observ=data.obs;
      this.spinnerService.activarLoading(true);
      this.clienteService.actualizarAdjuntoCliente(data).subscribe((resp:any)=>{
        this.spinnerService.activarLoading(false);
        console.log('Se actualizo correctamente');
        this.getAdjuntos()
      }, err => {
        if (err.status == 404) {
          this.spinnerService.activarLoading(false);
          console.log(err);
          basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
        }
      })
    })

  }
  descargarAdj(data){
    this.spinnerService.activarLoading(true);
    this.clienteService.descargarAdjuntoCliente(data.codcli, 'A', data.id).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response); 
  
      if (response.byteLength > 0) {
        // let file = new Blob([response], { type: 'application/vnd.ms-excel' });
        let file = new Blob([response], { type: data.formato });
  
        var fileURL = URL.createObjectURL(file);
        FileSaver.saveAs(fileURL, data.nombre);
      } else {
        basicAlert('No hay resultados', 'warning', 'Aceptar', null, null, null);
      }
  
    }, err => {
      if (err.status == 404) {
        this.spinnerService.activarLoading(false);
        console.log(err);
        basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
      }
    })
  }
}
